import { axios } from 'src/app/Axios';

import { IOrderBomPayload } from './apiTypes';

export const endPoint = {
    reOrderBom: (projectId: number) => `/project/${projectId}/bom/order/`
};

export const orderProjectBoms = ({ projectId, payload }: IOrderBomPayload) => axios.patch(endPoint.reOrderBom(projectId), payload);
